if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }

      this.setupAutoplay();
      
    }

    changeSlide(direction) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

    /* Automatisk skift mellem beskeder.

       Slaas til pr. sektion i temaeditoren og laeses fra data-attributter
       paa <announcement-bar>, saa JS'en ikke skal kende til Liquid.

       Fire ting den tager hoejde for:

       1. Temaeditoren springes over (Shopify.designMode). theme-editor.js
          scroller selv slideren hen til den blok merchanten vaelger — et
          autoplay ovenpaa ville rive udvalget vaek igen og goere det
          umuligt at redigere en enkelt besked.
       2. prefers-reduced-motion respekteres. Bevaegelse uden en bruger-
          handling er netop det den indstilling findes for.
       3. Pause ved hover og tastatur-fokus, saa en besked man er ved at
          laese eller et link man er ved at klikke paa ikke glider vaek.
       4. Pause naar fanen er skjult. setInterval bliver strubet i
          baggrunden, og uden pause hober skiftene sig op og baren
          springer flere beskeder frem naar man vender tilbage.

       Den vikler rundt (modulo), i modsaetning til pilene der stopper i
       hver ende — en kampagnebar skal koere i ring. */
    setupAutoplay() {

      if ( this.length < 2 ) return;
      if ( this.dataset.autoplay !== 'true' ) return;
      if ( window.Shopify && window.Shopify.designMode ) return;
      if ( window.matchMedia('(prefers-reduced-motion: reduce)').matches ) return;

      const seconds = parseInt(this.dataset.autoplayInterval, 10);
      const delay = ( isNaN(seconds) ? 5 : Math.max(2, seconds) ) * 1000;
      let timer = null;

      const advance = () => {
        this.index = ( this.index + 1 ) % this.length;
        if ( this.nextButton ) {
          this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
        }
        if ( this.prevButton ) {
          this.prevButton.classList.toggle('announcement-bar__content-nav--disabled', this.index === 0);
        }
        this.slider.scrollTo({
          top: 0,
          left: this.content[this.index].offsetLeft,
          behavior: 'smooth'
        });
      };

      const start = () => { if ( !timer ) timer = setInterval(advance, delay); };
      const stop = () => { clearInterval(timer); timer = null; };

      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', start);
      this.addEventListener('focusin', stop);
      this.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => {
        if ( document.hidden ) { stop(); } else { start(); }
      });

      start();

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}